import React from "react";
import { Tag } from "antd";
import { getSubjectByName } from "../../../constants/AppConstants";
const SubjectTag = ({subject})=>{
    const thisSubject = getSubjectByName(subject)
    return (<Tag color={thisSubject.color} className="gx-tag-style-subject-small">
    {thisSubject.displayName.toUpperCase()}
  </Tag>)
}
export default SubjectTag